import { useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";

export function ProviderValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    cpf: Yup.string().when("cnpj", {
      is: (cnpj: string) => !cnpj || cnpj.trim() === "",
      then: (schema) => schema.required(t("LABEL.required")),
      otherwise: (schema) => schema.optional(),
    }),
    cnpj: Yup.string().optional(),
    phone: Yup.string()
      .required(t("LABEL.required"))
      .test("is-valid-phone", t("LABEL.invalid phone"), (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value);
      }),
    address: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    comments: Yup.string().optional(),
    name_of_person_responsible: Yup.string()
      .matches(/^[A-Za-zÀ-ÿ\s]*$/, t("LABEl.only text"))
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    phone_person_responsible: Yup.string().required(t("LABEL.required")),
  });

  return validation;
}
